// extracted by mini-css-extract-plugin
module.exports = {"footerLinks":"footer-module--footer-links--1xwFE","gatsbyImage":"footer-module--gatsby-image--RS95w","emojiSize":"footer-module--emoji-size--1pG6I"};